import AccessControl, { ACCESS_LEVELS } from "@components/AccessControl";
import { Badge } from "@components/ui/badge";

const StaffBadge: React.FunctionComponent<{ className?: string }> = ({
  className,
}) => (
  <AccessControl level={ACCESS_LEVELS.STAFF}>
    <Badge variant="purple" className={className}>
      Staff
    </Badge>
  </AccessControl>
);

export default StaffBadge;
